"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cleanCourseTitle_1 = require("./utils/cleanCourseTitle");
var index_1 = require("./core/index");
var index_2 = require("./stem/index");
var index_3 = require("./business-industry/index");
var index_4 = require("./public-services/index");
var index_5 = require("./artsAndHumanities/index");
var endorsementBaseMath_1 = require("./endorsementBaseMath");
var endorsementBaseScience_1 = require("./endorsementBaseScience");
exports.default = function (courses) {
    courses = courses
        .map(function (c) { return (__assign({}, c, { course_title: cleanCourseTitle_1.default(c.course_title) })); })
        .sort(function (_a, _b) {
        var a = _a.course_title;
        var b = _b.course_title;
        if (a < b)
            return -1;
        if (a > b)
            return 1;
        return 0;
    });
    var courseMap = courses.reduce(function (map, c) {
        map[c.course_title.toLowerCase()] = c;
        return map;
    }, {});
    var validation = {
        core: index_1.default(courses, courseMap),
        stem: index_2.default(courses, courseMap),
        businessAndIndustry: index_3.default(courses, courseMap),
        publicServices: index_4.default(courses, courseMap),
        artsAndHumanities: index_5.default(courses, courseMap),
        endorsementBaseMath: endorsementBaseMath_1.default(courses, courseMap),
        endorsementBaseScience: endorsementBaseScience_1.default(courses, courseMap)
    };
    var schoolOfferings = {
        core: {
            validation: validation.core.validate(),
            options: validation.core.options
        },
        endorsementBaseMath: {
            validation: validation.endorsementBaseMath.validation(),
            options: validation.endorsementBaseMath.options
        },
        endorsementBaseScience: {
            validation: validation.endorsementBaseScience.validation(),
            options: validation.endorsementBaseScience.options
        },
        stem: {
            mathematics: {
                validation: validation.stem.mathematics.validate(),
                optionsBase: validation.stem.mathematics.optionsBase,
                optionsExtra: validation.stem.mathematics.optionsExtra
            },
            science: {
                validation: validation.stem.science.validate(),
                optionsBase: validation.stem.science.optionsBase,
                optionsExtra: validation.stem.science.optionsExtra
            },
            computerScience: {
                validation: validation.stem.computerScience.validate(),
                options: validation.stem.computerScience.options
            },
            combinationOfTwo: {
                validation: validation.stem.combinationOfTwo.validate(),
                optionsBase: validation.stem.combinationOfTwo.optionBase,
                optionsExtra: validation.stem.combinationOfTwo.optionExtra
            }
        },
        businessAndIndustry: {
            agriculture: {
                validation: validation.businessAndIndustry.agriculture.validate(),
                options: validation.businessAndIndustry.agriculture.options
            },
            architectureConstruction: {
                validation: validation.businessAndIndustry.architectureConstruction.validate(),
                options: validation.businessAndIndustry.architectureConstruction.options
            },
            artsTechCom: {
                validation: validation.businessAndIndustry.artsTechCom.validate(),
                options: validation.businessAndIndustry.artsTechCom.options
            },
            businessManagementAndAdministration: {
                validation: validation.businessAndIndustry.businessManagementAndAdministration.validate(),
                options: validation.businessAndIndustry.businessManagementAndAdministration
                    .options
            },
            finance: {
                validation: validation.businessAndIndustry.finance.validate(),
                options: validation.businessAndIndustry.finance.options
            },
            hospitalityAndTourism: {
                validation: validation.businessAndIndustry.hospitalityAndTourism.validate(),
                options: validation.businessAndIndustry.hospitalityAndTourism.options
            },
            informationTechnology: {
                validation: validation.businessAndIndustry.informationTechnology.validate(),
                options: validation.businessAndIndustry.informationTechnology.options
            },
            manufacturing: {
                validation: validation.businessAndIndustry.manufacturing.validate(),
                options: validation.businessAndIndustry.manufacturing.options
            },
            marketing: {
                validation: validation.businessAndIndustry.marketing.validate(),
                options: validation.businessAndIndustry.marketing.options
            },
            transportationDistributionAndLogistics: {
                validation: validation.businessAndIndustry.transportationDistributionAndLogistics.validate(),
                options: validation.businessAndIndustry.transportationDistributionAndLogistics
                    .options
            },
            english: {
                validation: validation.businessAndIndustry.english.validate(),
                options: validation.businessAndIndustry.english.options
            },
            technologyApplications: {
                validation: validation.businessAndIndustry.technologyApplications.validate(),
                options: validation.businessAndIndustry.technologyApplications.options
            }
        },
        publicServices: {
            lawPublicSafetyCorrectionsAndSecurity: {
                validation: validation.publicServices.lawPublicSafetyCorrectionsAndSecurity.validate(),
                options: validation.publicServices.lawPublicSafetyCorrectionsAndSecurity
                    .options
            },
            educationAndTraining: {
                validation: validation.publicServices.educationAndTraining.validate(),
                options: validation.publicServices.educationAndTraining.options
            },
            governmentAndPublicAdministration: {
                validation: validation.publicServices.governmentAndPublicAdministration.validate(),
                options: validation.publicServices.governmentAndPublicAdministration.options
            },
            healthScience: {
                validation: validation.publicServices.healthScience.validate(),
                options: validation.publicServices.healthScience.options
            },
            humanServices: {
                validation: validation.publicServices.humanServices.validate(),
                options: validation.publicServices.humanServices.options
            },
            jrotc: {
                validation: validation.publicServices.jrotc.validate(),
                options: validation.publicServices.jrotc.options
            }
        },
        artsAndHumanities: {
            multiLOTE: {
                validation: validation.artsAndHumanities.multiLOTE.validate(),
                options: validation.artsAndHumanities.multiLOTE.options
            },
            lote: {
                validation: validation.artsAndHumanities.lote.validate(),
                options: validation.artsAndHumanities.lote.options
            },
            socialStudies: {
                validation: validation.artsAndHumanities.socialStudies.validate(),
                options: validation.artsAndHumanities.socialStudies.options
            },
            americanSignLanguage: {
                validation: validation.artsAndHumanities.americanSignLanguage.validate(),
                options: validation.artsAndHumanities.americanSignLanguage.options
            },
            englishElectivesNotIncludedInBusinessAndIndustry: {
                validation: validation.artsAndHumanities.englishElectivesNotIncludedInBusinessAndIndustry.validate(),
                options: validation.artsAndHumanities
                    .englishElectivesNotIncludedInBusinessAndIndustry.options
            }
        }
    };
    return __assign({}, validation, { schoolOfferings: schoolOfferings });
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/index.js
// module id = 453
// module chunks = 22